export default async () => {
	if (!document.querySelector("#club-advantages-app")) return
	await window.appInitializer.initClubAdvantagesApp();
};
